<template>
  <div class="pa-4 text-left">
    <div class="text-h5 text-left">{{ $t('about.features.title') }}</div>
    <div class="px-10 py-4 features-description text-center">{{ $t('about.features.description') }}</div>
    <v-card
      class="d-flex justify-space-around flex-wrap mt-4 mb-2"
      flat
      tile
    >
      <FeaturesCard  
        v-for="(feature, index) in featuresList"
        :key="index"
        :feature="feature"
        :index="index"
      />
    </v-card>
  </div>
</template>

<script>
  import i18n from '../i18n';

  export default {
    components: {
      FeaturesCard: () => import('@/components/FeaturesCard')
    },
    data: () => ({
      featuresList: [
        { title: i18n.t('about.features.search'), description: i18n.t('about.features.searchDescription'), img:'ui_base.png', hover:'ui_base_search.png', icon: 'mdi-magnify' },
        { title: i18n.t('about.features.filter'), description: i18n.t('about.features.filterDescription'), img:'ui_base.png', hover:'ui_base_filter.png', icon: 'mdi-magnify-scan' },
        { title: i18n.t('about.features.create'), description: i18n.t('about.features.createDescription'), img:'ui_base.png', hover:'ui_base_create.png', icon: 'person_add' },
        { title: i18n.t('about.features.list'), description: i18n.t('about.features.listDescription'), img:'ui_base.png', hover:'ui_base_list.png', icon: 'mdi-clipboard-list-outline' },
        { title: i18n.t('about.features.update'), description: i18n.t('about.features.updateDescription'), img:'ui_base.png', hover:'ui_edit.png', icon: 'mdi-account-edit' },
        { title: i18n.t('about.features.attach'), description: i18n.t('about.features.attachDescription'), img:'ui_base.png', hover:'ui_base_link_transcript.png', icon: 'mdi-link-variant' },
        { title: i18n.t('about.features.personalization'), description: i18n.t('about.features.personalizationDescription'), img:'ui_base.png', hover:'ui_custom_fields.png', icon: 'dashboard_customize' }
      ],
    })
  }
</script>

<style lang="scss" scoped>
.card-subtitle {
  font-size: 1.2rem;
}

.card-description {
  font-size: 1.0rem;
}

.img-gray {
  filter: grayscale(1.0);
}

.img-gray:hover {
  filter: none;
}

.features-description {
  font-size: 1.5rem;
  font-weight: 300;
}
</style>